import { motion } from "framer-motion";

const easeOut = [0.22, 1, 0.36, 1];

/**
 * Fade + rise on first scroll into viewport. Feels like an editorial page
 * quietly settling into place. Not a canned template pop-in.
 */
export function Reveal({
  children,
  delay = 0,
  y = 32,
  duration = 0.9,
  className = "",
  as: Tag = "div",
  ...rest
}) {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y, filter: "blur(6px)" }}
      whileInView={{ opacity: 1, y: 0, filter: "blur(0)" }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration, ease: easeOut, delay }}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}

/**
 * Word-by-word reveal — used sparingly on hero headlines.
 * The words rise from a shallow offset, staggered by index.
 */
export function RevealWords({ text, className = "", delay = 0, wordClass = "" }) {
  const words = text.split(" ");
  return (
    <span className={className} aria-label={text}>
      {words.map((w, i) => (
        <span
          key={i}
          className="inline-block overflow-hidden align-bottom pr-[0.28em]"
        >
          <motion.span
            initial={{ y: "110%", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              duration: 0.9,
              ease: easeOut,
              delay: delay + i * 0.06,
            }}
            className={`inline-block ${wordClass}`}
            dangerouslySetInnerHTML={{ __html: w }}
          />
        </span>
      ))}
    </span>
  );
}

export default Reveal;
